import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/';
import helpers from '@/helpers/helpers';
import validation from '@/helpers/validation';

import VeeValidate, { Validator } from 'vee-validate';
import en from 'vee-validate/dist/locale/en';
import de from 'vee-validate/dist/locale/de';
import global_computed from '@/helpers/global-computed';

Vue.config.productionTip = false;

Vue.mixin(helpers);
Vue.mixin(validation);
Vue.mixin(global_computed);


//Validation
Vue.use(VeeValidate);
const dictionary = {
	en,
	de,
};

let lang = 'de';

Validator.localize(lang, dictionary[lang]);

window.app = new Vue({
	components:{
		App
	},
	router,
	store,
	template: '<App/>',
	//render: h => h()

	mounted(){
		this.$store.dispatch('userRefreshAction');
	}
}).$mount('#app');
